import * as angular from 'angular';
import { Constants as constants } from '@constants/shared';
import { simulation } from './simulations';
import { simulationTradeValidity } from './tradeValiditySimulation.modal';
import { securitySimulation } from './components/securitySimulation.component';
import { portfolioSimulation } from './components/portfolioSimulation.component';
import { cashBalanceDialog } from './cashBalance.dialog';

export const simulationsModule = 'simulation';

angular
  .module(simulationsModule, ['xeditable'])
  .constant('config', constants.Default)
  .component('simulations', simulation)
  .component('simulationTradeValidity', simulationTradeValidity)
  .component('cashBalanceDialog', cashBalanceDialog)
  .component('securitySimulation', securitySimulation)
  .component('portfolioSimulation', portfolioSimulation)



// WEBPACK FOOTER //
// ./src/app/simulations/simulations.index.ts